import { Check, Plus, X } from 'lucide-react';
import { Draft, Template } from '../../hooks/useDataCenterApi';


export function DraftsSidebar({
  drafts, currentDraftId, onSelect, onDelete, onCreate, templates, onApply,
}: {
  drafts: Draft[]
  currentDraftId: number | null
  onSelect: (id: number) => void
  onDelete: (id: number) => void
  onCreate: () => void
  templates: Template[]
  onApply: (code: string) => void
}) {
  return (
    <div style={{ padding: '8px 0' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 12px 8px' }}>
        <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.08em' }}>
          Черновики
        </div>
        <button
          type="button"
          onClick={onCreate}
          title="Создать чистый черновик из опубликованной модели"
          aria-label="Создать новый черновик"
          style={{
            display: 'inline-flex', alignItems: 'center', gap: 4,
            border: '1px solid var(--border-color)', borderRadius: 4,
            padding: '3px 6px', background: 'var(--bg-hover)',
            color: 'var(--text-secondary)', cursor: 'pointer', fontSize: 10,
          }}
        >
          <Plus size={11} /> Новый
        </button>
      </div>
      {drafts.length === 0 && (
        <p style={{ fontSize: 12, color: 'var(--text-muted)', padding: '4px 12px', fontStyle: 'italic' }}>Нет черновиков</p>
      )}
      {drafts.map(d => (
        <div
          key={d.id}
          onClick={() => onSelect(d.id)}
          style={{
            padding: '7px 12px',
            cursor: 'pointer',
            borderRadius: 5,
            margin: '2px 6px',
            background: currentDraftId === d.id ? 'var(--color-accent-blue-bg)' : 'transparent',
            border: currentDraftId === d.id ? '1px solid var(--color-accent-blue-border)' : '1px solid transparent',
            position: 'relative',
          }}
          onMouseEnter={e => { if (currentDraftId !== d.id) e.currentTarget.style.background = 'var(--bg-hover)' }}
          onMouseLeave={e => { if (currentDraftId !== d.id) e.currentTarget.style.background = 'transparent' }}
        >
          <div style={{ fontSize: 12, color: 'var(--text-primary)', fontWeight: 500 }}>{d.name}</div>
          <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 2, display: 'flex', gap: 8, alignItems: 'center' }}>
            <span style={{ color: d.published ? 'var(--status-normal)' : 'var(--status-warning)', display: 'inline-flex', alignItems: 'center', gap: 3 }}>
              {d.published ? <><Check size={11} /> Опубликован</> : '○ Черновик'}
            </span>
            <span>{d.updated_at ? new Date(d.updated_at).toLocaleDateString('ru-RU') : ''}</span>
          </div>
          {!d.published && (
            <button
              onClick={e => { e.stopPropagation(); onDelete(d.id) }}
              style={{
                position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)',
                background: 'transparent', border: 'none', color: 'var(--text-muted)', cursor: 'pointer', fontSize: 14, padding: 2,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}
              title="Удалить черновик"
            >
              <X size={12} />
            </button>
          )}
        </div>
      ))}

      {templates.length > 0 && (
        <>
          <div style={{ height: 1, background: 'var(--border-color)', margin: '10px 12px' }} />
          <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '0.08em', padding: '0 12px 8px' }}>
            Шаблоны
          </div>
          {templates.map(t => (
            <div key={t.id} style={{ padding: '6px 12px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <div>
                <div style={{ fontSize: 12, color: 'var(--text-primary)' }}>{t.name}</div>
              </div>
              <button
                onClick={() => onApply(t.code)}
                style={{
                  background: 'var(--color-accent-blue-bg)', border: '1px solid var(--color-accent-blue-border)',
                  borderRadius: 4, color: 'var(--color-accent-blue)', fontSize: 11, padding: '3px 8px', cursor: 'pointer',
                }}
              >
                Применить
              </button>
            </div>
          ))}
        </>
      )}
    </div>
  );
}
